import ApiService from "./ApiService";
import Appointment from "./models/Appointment";
import AppointmentRequest from "./models/AppointmentRequest";
import appointmentsConfig from "../constants/tables/appointments";
import { toISODate } from "@/utilities";


class AppointmentService {
  constructor() {
    this.appointments = [];
  }

  /**
   * Returns appointments
   */
  getAppointments() {
    return this.appointments;
  }

  /**
   * Returns appointments
   */
  getSortedByDateAppointments() {
    if (this.appointments.length === 0) {
      return this.appointments;
    }

    return this.appointments.sort((a, b) => b.datetime - a.datetime);
  }

  /**
   * Returns appointments filtered by date
   * @param date {string} - local date string
   */
  getAppointmentsByDate(date) {
    return this.appointments.filter(el => el.getDate() === date);
  }

  /**
   * Make request and returns mapped appointments list
   */
  async getAppointmentsAll(isArchive = false) {
    // get all today's and later appointments
    let today = toISODate(new Date());
    let config = {
      params: {
        slot_datetime__gte: today,
      },
    };

    // ... or archive appointments
    if (isArchive) {
      config['params'] = {
        slot_datetime__lt: today,
      };
    }

    this.appointments = [];

    // let res = await ApiService.get("/appointment/", config);
    let res = await ApiService.get("/appointment-request/", config);
    if (res.data.length > 0) {
       this.appointments = res.data.map(el => new AppointmentRequest(el, el.code));
    }
    return this.appointments;
  }

  /**
   * Make request and returns <Appointment>
   * @param code {string} - appointment code
   *
   * TODO: HACK: we use code here!
   */
  async getAppointmentById(code) {
    let res = await ApiService.get(`/appointment-request/${code}/`);
    return new AppointmentRequest(res.data, code);
  }

  /**
   * Make request and returns <AppointmentRequest> that user should accept or cancel
   * if user is authorised and his profile info is same as in appointment request, it will be autoaccepted
   * @param code {string} - appointment request code
   */
  async getAppointmentToAccept(code) {
    let res = await ApiService.get(`/appointment-request/${code}/`);
    return new AppointmentRequest(res.data, code);
  }
}
export default AppointmentService;
